module.exports = __webpack_public_path__ + "img/signup_choose_single_icon_01.08c7cadb.png";